<template>
  <div class="guide-shade" v-if="show">

    <div class="wrap">

      <div style=" padding-left: 10px; padding-right: 10px" class="guide-body">
        <div style="width: 273px; text-align: center; line-height: 25px; margin: 40px 0; font-size: 16px;">
          <div>{{title}}</div>
          <div v-if="title2">{{title2}}</div>
        </div>
        <div style="display: flex; flex-direction: row">
          <div @click="show = false" style="flex: 1; text-align: center; padding: 10px 0; border-top: #eee solid 0.5px; border-right: #eee solid 0.5px;">
            {{left || 取消}}
          </div>
          <div @click="changeChoice" style="flex: 1; text-align: center; padding: 10px 0; color: #ff6e00; border-top: #eee solid 0.5px;">
            {{right}}
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
  export default {
    props: ['show', 'title', 'title2', 'right', 'rightBtnClick', 'left'],
    data() {
      return {
        h: document.body.clientWidth + 'px',
        w: document.body.clientWidth + 'px',
      }
    },
    components: {},

    watch: {},

    methods: {
      changeChoice() {
        this.$emit('right-btn-click');
        this.show = false
      }
    }

  }
</script>

<style scoped>
  .wrap {
    position: relative;
    z-index: 202;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }

  .guide-shade {
    position: fixed;
    width: 100%;
    bottom: 0;
    height: 100%;
    left: 0;
    opacity: 1;
    z-index: 200;
    transition: opacity 0.3s;
    -webkit-transition: opacity 0.3s;
    background: rgba(0, 0, 0, 0.4);
  }

  .guide-body {
    position: absolute;
    background: #fafafa;
    width: 274px;
    border-radius: 5px;
  }

  /*.guide-body > div {*/
    /*text-align: center;*/
    /*opacity: 1;*/
    /*transition: opacity 0.1s;*/
    /*-webkit-transition: opacity 0.1s;*/
  /*}*/


</style>



// WEBPACK FOOTER //
// dialog.vue?05812b9e